import { useRouter } from 'next/router'

import type { Locale } from '@/i18n/config'
import { toLocale } from '@/i18n/config'

export const useLocale = (): Locale => {
    const { locale } = useRouter()
    return toLocale(locale)
}
